import axios from 'axios';
import {
  coreApi,
  setAuthTokenClients,
} from 'src/api/config';
import Notifier from 'common/helpers/Notifier';
import { UPDATE_USER } from 'actions';
import { env } from 'src/config/env';
import { get as getCookie, set as setCookie } from 'es-cookie';
import { setAxiosHeaders, secureProtocol } from 'src/common/utils/utils';
import { COOKIE_SESSION_KEY } from 'src/common/constants';

const onSuccess = async (dispatch, response, user) => {
  dispatch({
    type: UPDATE_USER,
    payload: response,
  });

  const tokenFromCookie = getCookie(COOKIE_SESSION_KEY);
  const { password, password_confirmation } = user;

  if (password && password_confirmation) {
    const parsedTokenCookie = JSON.parse(tokenFromCookie);
    const reqParams = {
      client_id: env.CLIENT_ID,
      refresh_token: parsedTokenCookie.refresh_token,
      grant_type: 'refresh_token',
    };
    const { data } = await axios.post(`${env.AUTH_URL}/oauth2/token`, reqParams);

    if (!data.refresh_token) {
      window.datadogLogs.logger.error(
        `Setting COOKIE_SESSION_KEY (4).
        Auth response: ${JSON.stringify(data, 0, 2)},
        Request params: ${JSON.stringify(reqParams, 0, 2)}`,
      );
    }
    setCookie(
      COOKIE_SESSION_KEY,
      JSON.stringify(data),
      { secure: secureProtocol },
    );
    setAxiosHeaders(data.access_token);
    setAuthTokenClients(data.access_token);
  }

  Notifier.dispatch(response.status, 'User Successfully Updated');
  return response;
};

const onError = (dispatch, error) => {
  Notifier.handleErrors(error);
  return error;
};

export default function updateEmployee(employeeId, user) {
  return async (dispatch) => {
    try {
      await coreApi.updateRecord('employee', employeeId, user);
      const employeeResponse = await coreApi.findRecord('employee', employeeId);
      return onSuccess(dispatch, employeeResponse, user);
    } catch (error) {
      return onError(dispatch, error);
    }
  };
}
